import React, { useEffect, useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-final-form";
import * as yup from "yup";
import UiInput from "../../../_uiComponents/UiInput";
import Validator from "../../../../_helpers/validate.schema";
import {
  loginAuthRequest,
  loginUserNameFEBAStore,
  otpConfirmRequest,
  dashboardClearAccountHistoryList,
  logoutAuthRequest,
} from "../../../../_redux/_actions";

import {
  getFingerPrint,
  keyGenerationFun,
  showCustomLoading,
} from "../../../../_helpers/support.services";
import {
  isUserLogginByCookie,
  removeUserDetails,
} from "../../../../_helpers/auth.helper";
import {
  authConstants,
  commonConstants,
  onboardingConstants,
  responseCodes,
} from "../../../../_redux/_constants";
import {
  UiButton,
  UiGradiantOutlinedBtn,
} from "../../../_uiComponents/common/UiButton";
import { UiVerticalButtonGroup } from "../../../_uiComponents/common/UiVerticalButtonGroup";
import Logo from "../../../../styles/img/df-logo.png";
import RoutesLink from "../../../../routes/RoutesLink";
import { clearCommonErrors } from "../../../../_redux/_actions";

import { useTranslation } from "react-i18next";
import {
  onboardingClearFormResponseData,
  onboardingClearFormData,
  storeCurrentStepDetails,
} from "../../../../_redux/_actions/onboarding.actions";
import { UiExpiryPassword } from "../../../_uiComponents/Auth/UiExpiryPassword";

const LoginForm = (props) => {
  const { t, i18n } = useTranslation();

  const validateSchema = () =>
    yup.object().shape({
      username: yup.string().required(t("This field is required")),
      password: yup.string().required(t("This field is required")),
    });

  const navigate = useNavigate();

  const actionDispatch = useDispatch();
  const [loginRequestSend, setLoginRequestSend] = useState(false);
  const [loginRequestObj, setLoginRequestObj] = useState({});
  const [passwordExpired, setPasswordExpired] = useState(false);

  const { loader, keyGeneration, userDetails, lang, commonData } = useSelector(
    (state) => {
      return {
        loader: state.loading,
        keyGeneration: state.keyGeneration,
        userDetails: state.auth?.userDetails,
        lang: state?.lang,
        commonData: state?.commonData,
      };
    },
  );

  const errorMessage = useSelector((state) => state.errorMessage);

  // Stale user cookie without tab session: clear client state  + logout API.
  useEffect(() => {
    if (isUserLogginByCookie()) {
      actionDispatch(logoutAuthRequest());
      removeUserDetails();
    }
  }, []);

  const submit = async (values) => {
    const fingetPrint = await getFingerPrint();
    const request = {
      username: values.username,
      password: values.password,
      uid: fingetPrint,
      locale: lang.defaultLang,
      setPasswordExpired: setPasswordExpired,
    };
    actionDispatch(dashboardClearAccountHistoryList());
    actionDispatch(loginAuthRequest(request));
    actionDispatch(loginUserNameFEBAStore(values.username));
    setLoginRequestObj(request);
  };

  const onValidate = async (values) => {
    return await Validator(values, validateSchema);
  };

  useEffect(() => {
    if (keyGeneration.regenerateKey) {
      async function initlizeData() {
        await keyGenerationFun(actionDispatch, true);
        setLoginRequestSend(true);
      }
      initlizeData();
    }
  }, [keyGeneration?.regenerateKey]);

  // this line is commented due to auto reloading non stop issue, might need in the future

  // useEffect(() => {

  //   if (

  //     keyGeneration.keyGenerationStatus == commonConstants.STATUS_SUCCESS &&

  //     loginRequestSend

  //   ) {

  //     actionDispatch(loginAuthRequest(loginRequestObj));

  //   }

  // }, [keyGeneration.keyGenerationStatus, loginRequestSend]);

  const navigateToForgotFlow = () => {
    navigate("/forgot-username");
  };

  const navigateToOnboardingFlow = () => {
    actionDispatch(
      storeCurrentStepDetails({
        stepName: onboardingConstants.NIC_PASSPORT_VALIDATION_STEP,
      }),
    );
    actionDispatch(onboardingClearFormData());
    actionDispatch(onboardingClearFormResponseData());
    navigate("/onboarding-flow");
  };

  useEffect(() => {
    if (errorMessage?.customErrors.length > 0) {
      var status = errorMessage?.customErrors[0];
      if (status.statusCode == responseCodes.AUTH_ERROR_PASSWORD_EXPIRED) {
        actionDispatch(clearCommonErrors());
      }
    }
  }, [errorMessage]);

  return (
    <>
      <div className="df-login-form">
        <div className="df-login-form__header">
          <img src={Logo} />
          <h1>{t("Welcome to LOLC Online Banking")}</h1>
          <h2>{t("Login")}</h2>
          <p>{t("Enter your username and password to login")}</p>
        </div>

        <div className="df-login-form__form">
          <Form
            initialValues={{
              username: commonData?.forgotRecoveredUsername ?? "",
            }}
            onSubmit={submit}
            validate={onValidate}
            render={({
              handleSubmit,
              values,
              submitting,
              error,
              hasValidationErrors,
              form,
            }) => {
              return (
                <form
                  onSubmit={handleSubmit}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleSubmit();
                    }
                  }}
                >
                  <UiInput
                    name="username"
                    id="inputUserName"
                    label={`${t("Username")} *`}
                    type="text"
                    clearable={true}
                    maxLength={20}
                    form={form}
                    showErrorOutFous
                    autoComplete="off"
                    value={values?.username}
                    //commented due to request from QA side (to remove preventing copy paste)
                    // onCopy={(event) => {
                    //   event.preventDefault();
                    // }}
                    // onPaste={(event) => {
                    //   event.preventDefault();
                    // }}
                    // onCut={(event) => {
                    //   event.preventDefault();
                    // }}
                  />
                  <UiInput
                    name="password"
                    id="inputUserPw"
                    label={`${t("Password")} *`}
                    type="password"
                    clearable={true}
                    maxLength="32"
                    form={form}
                    autoComplete="off"
                    onCopy={(event) => {
                      event.preventDefault();
                    }}
                    onPaste={(event) => {
                      event.preventDefault();
                    }}
                    onCut={(event) => {
                      event.preventDefault();
                    }}
                  />
                  <div className="text-right">
                    <UiButton
                      name={t("Forgot login details?")}
                      onClick={() => {
                        navigateToForgotFlow();
                      }}
                      className="df-primary-underlined-btn "
                    />
                  </div>

                  <UiVerticalButtonGroup>
                    <UiButton
                      className="df-ui-dark-bg-btn"
                      disabled={hasValidationErrors}
                      size={"lg"}
                      variant="primary"
                      onClick={handleSubmit}
                      type="submit"
                      text="Login"
                      isLoading={showCustomLoading(
                        [authConstants.AUTH_LOGIN_REQUEST],
                        loader?.pendingRequests ? loader.pendingRequests : [],
                      )}
                      name={t("Log In")}
                    />

                    <div
                      className="df-login-create-account-link"
                      onClick={() => navigateToOnboardingFlow()}
                    >
                      {t(
                        "Start your journey with LOLC Realtime, Create an account.",
                      )}
                    </div>
                  </UiVerticalButtonGroup>
                </form>
              );
            }}
          />
        </div>
      </div>

      <UiExpiryPassword
        isOpen={passwordExpired}
        handleClose={setPasswordExpired}
      />
    </>
  );
};

export default LoginForm;
